<template>
  <div class="container lnb d_container">
    <div class="contents_wrap no_height">
      <div class="contents list-container">
        <div class="title">{{ this.$route.meta.title }}</div>
        <div class="write_tab mb20">
          <div class="write_tab_content tab_member_detail active">
            기본정보
          </div>
          <div class="write_tab_content tab_member_detail" @click="movePage(`/item/utility/${utilKey}/manager`)">
            매니저
          </div>
          <div class="write_tab_content tab_member_detail" @click="movePage(`/item/utility/${utilKey}/pubcurrent`)">
            발행현황
          </div>
        </div>
        <utility-pub-detail-component :utility-type="'utilityPublish'" :utilKey="utilKey"></utility-pub-detail-component>
        <div class="pa15 text-center btn_wrap">
          <el-button class="com_btn" type="button" @click="movePage('/item/utility')">목록</el-button>
<!--          <el-button class="reg_btn_out"  type="button" @click="utilDelete(utilKey)">삭제</el-button>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UtilityPubDetailComponent from "@/components/utility/UtilityPubDetailComponent.vue";
import EventBus from "@/utils/event-bus";

export default {
  name: "UtilityDetailPublish",
  mixins: [],
  components: {UtilityPubDetailComponent},
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
      utilKey: Number(this.$route.params.idx),
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
  },
  beforeUnmount() {
  },
  unmounted() {
  },
  computed: {},
  methods: {
    movePage(url){
        EventBus.$emit('apiLoading', true);
      this.$router.push(url);
    },
    utilDelete(key){
      EventBus.$emit('utilDelete', key);
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>
